import {onDomReady} from "../../components/dynamic/observer";

class Cases {
    constructor() {
        this.items = document.querySelectorAll('[data-cases-item]');
        this.loadMoreBtn = document.querySelector('[data-load-more]');
        this.visibleCount = 12;

        this.init();
    }

    init() {
        if (!this.items.length) return;

        this.hideExtraItems();
        this.bindEvents();
    }

    hideExtraItems() {
        this.items.forEach((item, index) => {
            if (index >= this.visibleCount) {
                item.style.display = 'none';
            }
        });
    }

    showAllItems() {
        this.items.forEach(item => {
            item.style.display = '';
        });
        this.loadMoreBtn.style.display = 'none';
    }

    bindEvents() {
        if (this.loadMoreBtn) {
            this.loadMoreBtn.addEventListener('click', (e) => {
                e.preventDefault();
                this.showAllItems();
            });
        }
    }
}

onDomReady(() => {
    const items = document.querySelectorAll('[data-cases-item]');
    if (items) {
        new Cases();
    }
});
